(function() {
    'use strict';

    var marker = '__ekselansCartDrawerOpenFix20260701';
    if (window[marker]) return;
    window[marker] = true;

    var cartOpenInProgress = false;
    var addIntentTimer = null;
    var lastCartSignature = '';
    var sidebarObserver = null;
    var contentObserver = null;
    var contentRepairTimer = null;
    var contentRepairInProgress = false;
    var shippingEstimateSelector = [
        '.function-block--cart-shipping',
        '[data-drawer-toggle="#Drawer-CartShipping"]',
        '#Drawer-CartShipping',
        '.cart-tool-shipping',
        '.cartTool-item[data-popup="popup-tool-shipping"]',
        '#popup-tool-shipping',
        '.cart-shipping-calculator',
        '.shipping-calculator-form'
    ].join(',');
    var shippingEstimateText = /Schat de verzendkosten|Estimate shipping|Calculate shipping|Verzendkosten/i;

    function cartRoot() {
        var root = window.routes && window.routes.root ||
            window.Shopify && window.Shopify.routes && window.Shopify.routes.root ||
            '/';

        root = String(root || '/');
        return root.charAt(root.length - 1) === '/' ? root : root + '/';
    }

    function cartUrl(path) {
        return cartRoot() + String(path || '').replace(/^\//, '');
    }

    function isCartPage() {
        return document.body && document.body.classList.contains('template-cart');
    }

    function cartLinkPath(link) {
        try {
            var parsed = new URL(link.getAttribute('href') || '', window.location.origin);
            if (parsed.origin !== window.location.origin) return '';
            return parsed.pathname.replace(/\/+$/, '');
        } catch (error) {
            return '';
        }
    }

    function isDrawerViewCartLink(target) {
        var link = target && target.closest && target.closest('a[href]');
        if (!link || !/\/cart$/.test(cartLinkPath(link))) return false;

        return !!(
            link.classList.contains('button-view-cart') ||
            link.closest('#halo-cart-sidebar, .halo-cart-sidebar, .previewCartInfo') ||
            /bekijk winkelwagen|winkelwagen bekijken|view cart|sepet/i.test(link.textContent || '')
        );
    }

    function isCartTrigger(target) {
        if (!target || !target.closest) return false;
        if (isDrawerViewCartLink(target)) return false;
        return target.closest('[data-cart-sidebar], .header__icon--cart, .list-item-cart, a[href$="/cart"]');
    }

    function isAddToCartTrigger(target) {
        if (!target || !target.closest) return false;
        return target.closest('[data-btn-addtocart], #product-add-to-cart, button[name="add"], input[name="add"]');
    }

    function sidebarWrapper() {
        return document.querySelector('#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper');
    }

    function removeShippingEstimateNodes() {
        var sidebar = document.querySelector('#halo-cart-sidebar');
        if (!sidebar) return;

        sidebar.querySelectorAll(shippingEstimateSelector).forEach(function(element) {
            element.remove();
        });

        sidebar.querySelectorAll('button, a, h2, h3, p, label, span, div').forEach(function(element) {
            if (element === sidebar || element.id === 'halo-cart-sidebar') return;
            if (!shippingEstimateText.test((element.textContent || '').replace(/\s+/g, ' '))) return;

            var removable = element.closest(shippingEstimateSelector);
            if (removable && removable !== sidebar) {
                removable.remove();
                return;
            }

            if (element.children.length <= 3 && element.textContent.length < 160) {
                element.remove();
            }
        });
    }

    function repairSidebarVisibility() {
        var sidebar = document.querySelector('#halo-cart-sidebar');
        if (!sidebar || !document.body || !document.body.classList.contains('cart-sidebar-show')) return;

        removeShippingEstimateNodes();
        sidebar.removeAttribute('hidden');
        if (sidebar.getAttribute('aria-hidden') === 'true') sidebar.removeAttribute('aria-hidden');
        sidebar.style.removeProperty('display');
        sidebar.style.removeProperty('visibility');

        var style = window.getComputedStyle ? window.getComputedStyle(sidebar) : null;
        if (!style || style.display === 'none') {
            sidebar.style.setProperty('display', 'block', 'important');
        }
        if (!style || style.visibility === 'hidden') {
            sidebar.style.setProperty('visibility', 'visible', 'important');
        }
    }

    function scheduleSidebarRepair() {
        [0, 80, 180, 360, 700, 1200].forEach(function(delay) {
            window.setTimeout(repairSidebarVisibility, delay);
        });
    }

    function observeSidebarVisibility() {
        if (sidebarObserver || !window.MutationObserver) return;

        var sidebar = document.querySelector('#halo-cart-sidebar');
        if (!sidebar) return;

        sidebarObserver = new MutationObserver(function() {
            if (document.body && document.body.classList.contains('cart-sidebar-show')) {
                window.setTimeout(repairSidebarVisibility, 0);
            }
        });

        sidebarObserver.observe(sidebar, {
            attributes: true,
            attributeFilter: ['hidden', 'aria-hidden', 'style', 'class'],
            childList: true,
            subtree: true
        });
    }

    function cartSignature(cart) {
        if (!cart || !Array.isArray(cart.items)) return '';
        return [
            cart.item_count || 0,
            cart.total_price || 0,
            cart.items.map(function(item) {
                return [
                    item.key || item.id || item.variant_id || '',
                    item.quantity || 0,
                    item.final_line_price || item.line_price || 0
                ].join(':');
            }).join('|')
        ].join('|');
    }

    function getCart() {
        return fetch(cartUrl('cart.js'), {
            credentials: 'same-origin',
            cache: 'no-store'
        }).then(function(response) {
            if (!response.ok) throw new Error('Cart JSON ' + response.status);
            return response.json();
        });
    }

    function getSidebarHtml() {
        return fetch(cartUrl('cart?view=ajax_side_cart'), {
            credentials: 'same-origin',
            cache: 'no-store'
        }).then(function(response) {
            if (!response.ok) throw new Error('Cart sidebar ' + response.status);
            return response.text();
        });
    }

    function updateCartCount(cart) {
        if (!cart) return;

        document.querySelectorAll('[data-cart-count]').forEach(function(element) {
            element.textContent = cart.item_count >= 100 && window.cartStrings ?
                window.cartStrings.item_99 :
                cart.item_count;
        });

        document.querySelectorAll('[data-cart-text]').forEach(function(element) {
            if (!window.cartStrings) return;
            element.textContent = cart.item_count === 1 ? window.cartStrings.item : window.cartStrings.items;
        });
    }

    function removeLoading(wrapper) {
        if (!wrapper) return;
        wrapper.classList.remove('is-loading');
        wrapper.querySelectorAll('.loading-overlay, .loading-overlay--custom').forEach(function(loader) {
            loader.remove();
        });
    }

    function escapeHtml(value) {
        return String(value == null ? '' : value).replace(/[&<>"']/g, function(character) {
            return {
                '&': '&amp;',
                '<': '&lt;',
                '>': '&gt;',
                '"': '&quot;',
                "'": '&#39;'
            }[character];
        });
    }

    function formatMoney(cents) {
        if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
            return window.Shopify.formatMoney(cents);
        }

        try {
            return new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', {
                style: 'currency',
                currency: window.Shopify && window.Shopify.currency && window.Shopify.currency.active || 'EUR'
            }).format((Number(cents) || 0) / 100);
        } catch (error) {
            return '€' + ((Number(cents) || 0) / 100).toFixed(2).replace('.', ',');
        }
    }

    function cartLabel(key) {
        var lang = (document.documentElement.lang || 'nl').toLowerCase();
        var labels = {
            checkout: lang.indexOf('tr') === 0 ? 'SATIN AL' : lang.indexOf('en') === 0 ? 'CHECKOUT' : 'AFREKENEN',
            viewCart: lang.indexOf('tr') === 0 ? 'SEPETI GORUNTULE' : lang.indexOf('en') === 0 ? 'VIEW CART' : 'BEKIJK WINKELWAGEN',
            subtotal: lang.indexOf('tr') === 0 ? 'Ara toplam' : lang.indexOf('en') === 0 ? 'Subtotal' : 'Subtotaal',
            total: lang.indexOf('tr') === 0 ? 'Toplam' : lang.indexOf('en') === 0 ? 'Total' : 'Totaal',
            remove: lang.indexOf('tr') === 0 ? 'Kaldir' : lang.indexOf('en') === 0 ? 'Remove' : 'Verwijderen'
        };

        return labels[key] || '';
    }

    function normalizeSidebarHtml(html) {
        if (!html) return '';

        var container = document.createElement('div');
        container.innerHTML = html;
        var nestedWrapper = container.querySelector('.previewCart-wrapper');

        if (nestedWrapper) return nestedWrapper.innerHTML;
        return html;
    }

    function drawerHasExpectedContent(wrapper, cart) {
        if (!wrapper) return false;
        if (!cart || !cart.item_count) {
            return !!wrapper.querySelector('.previewCart-emptyBody, .previewCart');
        }

        return !!wrapper.querySelector('.previewCartItem, [data-item-row]');
    }

    function drawerHasItemRows(wrapper) {
        return !!(wrapper && wrapper.querySelector('.previewCartItem, [data-item-row]'));
    }

    function fallbackCartHtml(cart) {
        if (!cart || !cart.item_count || !Array.isArray(cart.items)) {
            return [
                '<div class="previewCart">',
                '  <div class="previewCart-emptyBody text-center"></div>',
                '</div>'
            ].join('');
        }

        var itemsHtml = cart.items.map(function(item, index) {
            var image = item.featured_image && item.featured_image.url || item.image || '';
            var title = item.product_title || item.title || '';
            var variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
            var lineKey = item.key || item.id || '';
            var variantId = item.variant_id || item.id || '';
            var itemUrl = item.url || '/cart';
            var price = item.final_line_price != null ? item.final_line_price : item.line_price;

            return [
                '<li class="previewCartItem clearfix" data-item-row>',
                '  <a href="' + escapeHtml(itemUrl) + '" class="previewCartItem-image">',
                image ? '    <img src="' + escapeHtml(image) + '" width="110" alt="' + escapeHtml(title) + '" loading="lazy">' : '',
                '  </a>',
                '  <div class="previewCartItem-content cart-item-block-right">',
                '    <a class="previewCartItem-name link-underline card-title" href="' + escapeHtml(itemUrl) + '"><span class="text">' + escapeHtml(title) + '</span></a>',
                variantTitle ? '    <div class="previewCartItem-options"><span class="previewCartItem-variant">' + escapeHtml(variantTitle) + '</span></div>' : '',
                '    <div class="previewCartItem-change">',
                '      <div class="previewCartItem-price"><span class="price"><span data-item-final-price-display>' + formatMoney(price) + '</span></span></div>',
                '      <cart-update-quantity class="previewCartItem-qty" data-product="' + escapeHtml(item.product_id || '') + '" data-variant="' + escapeHtml(variantId) + '">',
                '        <a role="link" aria-disabled="true" class="minus btn-quantity" data-minus-quantity-cart></a>',
                '        <input class="form-input quantity" name="quantity" id="fallback-cart-update-' + index + '" value="' + escapeHtml(item.quantity || 1) + '" type="number" data-cart-quantity data-cart-quantity-id="' + escapeHtml(variantId) + '" data-line="' + escapeHtml(lineKey) + '" data-index="' + (index + 1) + '">',
                '        <a role="link" aria-disabled="true" class="plus btn-quantity" data-plus-quantity-cart></a>',
                '      </cart-update-quantity>',
                '    </div>',
                '  </div>',
                '  <button type="button" class="previewCartItem-remove" data-cart-remove data-cart-remove-id="' + escapeHtml(variantId) + '" data-line="' + escapeHtml(lineKey) + '" data-index="' + (index + 1) + '" title="' + escapeHtml(cartLabel('remove')) + '">',
                '    <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
                '  </button>',
                '</li>'
            ].join('');
        }).join('');

        return [
            '<div class="previewCart">',
            '  <ul class="previewCartList list-unstyled">',
            itemsHtml,
            '  </ul>',
            '</div>',
            '<div class="previewCartInfo">',
            '  <ul class="previewCartTotalsPrice list-unstyled">',
            '    <li class="previewCartTotals subTotal clearfix"><div class="previewCartTotals-label">' + escapeHtml(cartLabel('subtotal')) + ':</div><div class="previewCartTotals-value" data-cart-subtotal>' + formatMoney(cart.original_total_price != null ? cart.original_total_price : cart.total_price) + '</div></li>',
            '    <li class="previewCartTotals total clearfix"><div class="previewCartTotals-label">' + escapeHtml(cartLabel('total')) + '</div><div class="previewCartTotals-value" data-cart-total-value="' + escapeHtml(cart.total_price || 0) + '">' + formatMoney(cart.total_price) + '</div></li>',
            '  </ul>',
            '  <div class="previewCartAction text-left">',
            '    <div class="previewCartGroup">',
            '      <button class="button button-1 button-checkout" onclick="window.location=' + "'/checkout'" + '" id="cart-sidebar-checkout">' + escapeHtml(cartLabel('checkout')) + '</button>',
            '      <a class="button button-2 button-view-cart" href="' + cartUrl('cart') + '">' + escapeHtml(cartLabel('viewCart')) + '</a>',
            '    </div>',
            '  </div>',
            '</div>'
        ].join('');
    }

    function fillFallbackCart(wrapper, cart) {
        if (!wrapper || drawerHasExpectedContent(wrapper, cart)) return false;
        wrapper.innerHTML = fallbackCartHtml(cart);
        return true;
    }

    function scheduleContentRepair(cart, html) {
        var normalizedHtml = normalizeSidebarHtml(html);

        [120, 420, 900, 1600].forEach(function(delay, index) {
            window.setTimeout(function() {
                var wrapper = sidebarWrapper();
                if (!wrapper || drawerHasExpectedContent(wrapper, cart)) return;

                removeLoading(wrapper);

                if (normalizedHtml && /previewCart/i.test(normalizedHtml)) {
                    wrapper.innerHTML = normalizedHtml;
                    removeShippingEstimateNodes();
                }

                if (drawerHasExpectedContent(wrapper, cart)) return;

                if (index < 2) {
                    getSidebarHtml().then(function(freshHtml) {
                        var nextHtml = normalizeSidebarHtml(freshHtml);
                        if (nextHtml && /previewCart/i.test(nextHtml)) {
                            wrapper.innerHTML = nextHtml;
                            removeShippingEstimateNodes();
                        }
                        fillFallbackCart(wrapper, cart);
                    }).catch(function() {
                        fillFallbackCart(wrapper, cart);
                    });
                    return;
                }

                fillFallbackCart(wrapper, cart);
            }, delay);
        });
    }

    function repairBlankOpenDrawer(reason) {
        var wrapper = sidebarWrapper();

        if (!document.body ||
            !document.body.classList.contains('cart-sidebar-show') ||
            isCartPage() ||
            !wrapper ||
            drawerHasItemRows(wrapper) ||
            contentRepairInProgress) {
            return;
        }

        contentRepairInProgress = true;

        Promise.all([
            getCart(),
            getSidebarHtml().catch(function() { return ''; })
        ]).then(function(results) {
            var cart = results[0];
            var html = normalizeSidebarHtml(results[1]);

            if (!cart || !cart.item_count || drawerHasExpectedContent(wrapper, cart)) return;

            if (html && /previewCart/i.test(html)) {
                removeLoading(wrapper);
                wrapper.innerHTML = html;
                removeShippingEstimateNodes();
            }

            if (!drawerHasExpectedContent(wrapper, cart)) {
                fillFallbackCart(wrapper, cart);
            }

            updateCartCount(cart);
            repairSidebarVisibility();
            scheduleContentRepair(cart, html);
        }).finally(function() {
            window.setTimeout(function() {
                contentRepairInProgress = false;
            }, 120);
        });
    }

    function scheduleBlankDrawerCheck(delay) {
        window.clearTimeout(contentRepairTimer);
        contentRepairTimer = window.setTimeout(function() {
            repairBlankOpenDrawer('scheduled');
        }, delay == null ? 240 : delay);
    }

    function observeDrawerContent() {
        if (contentObserver || !window.MutationObserver) return;

        contentObserver = new MutationObserver(function() {
            scheduleBlankDrawerCheck(180);
        });

        contentObserver.observe(document.body || document.documentElement, {
            attributes: true,
            attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'],
            childList: true,
            subtree: true
        });
    }

    function showDrawer() {
        if (!document.body || isCartPage()) return;
        document.body.classList.add('cart-sidebar-show');
        observeSidebarVisibility();
        observeDrawerContent();
        repairSidebarVisibility();
        scheduleBlankDrawerCheck(320);
        scheduleSidebarRepair();
    }

    function hydrateDrawer(cart, html) {
        var wrapper = sidebarWrapper();

        showDrawer();
        updateCartCount(cart);

        if (wrapper && html) {
            html = normalizeSidebarHtml(html);
            removeLoading(wrapper);
            wrapper.innerHTML = html;
            removeShippingEstimateNodes();
        }

        scheduleContentRepair(cart, html);
        repairSidebarVisibility();

        if (window.halo && typeof window.halo.dispatchChangeForShippingMessage === 'function') {
            window.halo.dispatchChangeForShippingMessage();
        }

        if (window.halo && typeof window.halo.productCollectionCartSlider === 'function') {
            window.setTimeout(function() {
                window.halo.productCollectionCartSlider();
            }, 0);
        }

        if (window.halo && typeof window.halo.updateGiftWrapper === 'function') {
            window.halo.updateGiftWrapper();
        }

        document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));
        scheduleSidebarRepair();
    }

    function openCartDrawer(options) {
        if (isCartPage()) return Promise.resolve(false);
        showDrawer();

        if (cartOpenInProgress && !(options && options.force)) {
            return Promise.resolve(false);
        }

        cartOpenInProgress = true;

        return Promise.all([getCart(), getSidebarHtml()])
            .then(function(results) {
                var cart = results[0];
                var html = results[1];
                lastCartSignature = cartSignature(cart);
                hydrateDrawer(cart, html);
                return true;
            })
            .catch(function() {
                showDrawer();
                return false;
            })
            .finally(function() {
                window.setTimeout(function() {
                    cartOpenInProgress = false;
                }, 150);
            });
    }

    function handleCartClick(event) {
        var trigger = isCartTrigger(event.target);
        if (!trigger || isCartPage()) return;

        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();

        openCartDrawer({ force: true });
    }

    function scheduleOpenIfCartChanged(beforeSignature) {
        window.clearTimeout(addIntentTimer);

        var attempts = 0;
        function check() {
            attempts += 1;

            getCart().then(function(cart) {
                var nextSignature = cartSignature(cart);
                if (nextSignature && nextSignature !== beforeSignature) {
                    lastCartSignature = nextSignature;
                    openCartDrawer({ force: true });
                    return;
                }

                if (attempts < 5) {
                    addIntentTimer = window.setTimeout(check, attempts < 2 ? 450 : 800);
                }
            }).catch(function() {
                if (attempts < 5) {
                    addIntentTimer = window.setTimeout(check, 800);
                }
            });
        }

        addIntentTimer = window.setTimeout(check, 500);
    }

    function handleAddToCartClick(event) {
        if (!isAddToCartTrigger(event.target) || isCartPage()) return;

        getCart()
            .then(function(cart) {
                scheduleOpenIfCartChanged(cartSignature(cart));
            })
            .catch(function() {
                scheduleOpenIfCartChanged(lastCartSignature);
            });
    }

    function wrapsCartAddUrl(input) {
        var value = '';

        if (typeof input === 'string') {
            value = input;
        } else if (input && input.url) {
            value = input.url;
        }

        return /\/cart\/add(?:\.js)?(?:\?|$)/.test(value);
    }

    function patchFetch() {
        if (!window.fetch || window.fetch.__ekselansCartDrawerOpenFix) return;

        var originalFetch = window.fetch;
        window.fetch = function(input, init) {
            var isCartAdd = wrapsCartAddUrl(input);
            return originalFetch.apply(this, arguments).then(function(response) {
                if (isCartAdd && response && response.ok) {
                    window.setTimeout(function() {
                        openCartDrawer({ force: true });
                    }, 180);
                }
                return response;
            });
        };
        window.fetch.__ekselansCartDrawerOpenFix = true;
    }

    function patchXhr() {
        if (!window.XMLHttpRequest || window.XMLHttpRequest.__ekselansCartDrawerOpenFix) return;

        var originalOpen = XMLHttpRequest.prototype.open;
        var originalSend = XMLHttpRequest.prototype.send;

        XMLHttpRequest.prototype.open = function(method, url) {
            this.__ekselansCartAddRequest = /\/cart\/add(?:\.js)?(?:\?|$)/.test(String(url || ''));
            return originalOpen.apply(this, arguments);
        };

        XMLHttpRequest.prototype.send = function() {
            if (this.__ekselansCartAddRequest) {
                this.addEventListener('load', function() {
                    if (this.status >= 200 && this.status < 300) {
                        window.setTimeout(function() {
                            openCartDrawer({ force: true });
                        }, 180);
                    }
                });
            }
            return originalSend.apply(this, arguments);
        };

        window.XMLHttpRequest.__ekselansCartDrawerOpenFix = true;
    }

    document.addEventListener('click', handleCartClick, true);
    document.addEventListener('click', handleAddToCartClick, true);
    document.addEventListener('cart-update', function(event) {
        if (event && event.detail) {
            lastCartSignature = cartSignature(event.detail);
        }
    });

    patchFetch();
    patchXhr();
    observeSidebarVisibility();
    observeDrawerContent();
    scheduleBlankDrawerCheck(800);

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            getCart().then(function(cart) {
                lastCartSignature = cartSignature(cart);
            }).catch(function() {});
        });
    } else {
        getCart().then(function(cart) {
            lastCartSignature = cartSignature(cart);
        }).catch(function() {});
    }
})();

(function() {
    'use strict';

    var marker = '__ekselansMobileMenuStripEnLinks20260703';
    if (window[marker]) return;
    window[marker] = true;

    var internalPathPattern = /^\/en(\/(?:collections|products|search|pages|blogs|cart|account)(?:\/|\?|#|$))/;
    var scopedSelectors = [
        'template',
        '[id^="MenuMobileSection-"]',
        '[id^="MenuMobileListSection-"]',
        '.menu-drawer',
        '.halo-sidebar-menu',
        '.halo-sidebar_menu',
        '.mobile-menu',
        '.nav-mobile-menu-tab'
    ].join(',');

    function normalizedHref(href) {
        if (!href) return href;

        if (internalPathPattern.test(href)) {
            return href.replace(/^\/en/, '') || '/';
        }

        try {
            var parsed = new URL(href, window.location.origin);
            if (parsed.origin !== window.location.origin) return href;
            if (!internalPathPattern.test(parsed.pathname)) return href;
            return parsed.pathname.replace(/^\/en/, '') + parsed.search + parsed.hash;
        } catch (error) {
            return href;
        }
    }

    function patchLinksIn(root) {
        if (!root || !root.querySelectorAll) return;

        root.querySelectorAll('a[href]').forEach(function(link) {
            var href = link.getAttribute('href');
            var nextHref = normalizedHref(href);
            if (nextHref && nextHref !== href) {
                link.setAttribute('href', nextHref);
            }
        });
    }

    function patchMobileMenuLinks(root) {
        var scope = root && root.querySelectorAll ? root : document;

        if (scope.matches && scope.matches(scopedSelectors)) {
            if (scope.tagName && scope.tagName.toLowerCase() === 'template') {
                patchLinksIn(scope.content);
            } else {
                patchLinksIn(scope);
            }
        }

        scope.querySelectorAll(scopedSelectors).forEach(function(element) {
            if (element.tagName && element.tagName.toLowerCase() === 'template') {
                patchLinksIn(element.content);
            } else {
                patchLinksIn(element);
            }
        });
    }

    function schedulePatch(root) {
        window.setTimeout(function() {
            patchMobileMenuLinks(root || document);
        }, 0);
    }

    schedulePatch(document);
    document.addEventListener('DOMContentLoaded', function() {
        schedulePatch(document);
    });
    window.addEventListener('load', function() {
        schedulePatch(document);
    });
    document.addEventListener('click', function(event) {
        if (event.target && event.target.closest && event.target.closest(scopedSelectors)) {
            patchMobileMenuLinks(document);
        }
    }, true);

    if (window.MutationObserver) {
        new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                mutation.addedNodes.forEach(function(node) {
                    if (node && node.nodeType === 1) {
                        schedulePatch(node);
                    }
                });
            });
        }).observe(document.documentElement, {
            childList: true,
            subtree: true
        });
    }
})();
